var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H2C.9 0 .01.9.01 2L0 14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V2l8 5 8-5v2z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDIwIDE2Ij48cGF0aCBkPSJNMTgsMCBMMiwwIEMwLjksMCAwLjAxLDAuOSAwLjAxLDIgTDAsMTQgQzAsMTUuMSAwLjksMTYgMiwxNiBMMTgsMTYgQzE5LjEsMTYgMjAsMTUuMSAyMCwxNCBMMjAsMiBDMjAsMC45IDE5LjEsMCAxOCwwIFogTTE4LDQgTDEwLDkgTDIsNCBMMiwyIEwxMCw3IEwxOCwyIEwxOCw0IFoiLz48L3N2Zz4=";
export { SvgEmail as ReactComponent };